import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SupervisorUserDTO } from 'src/app/model/base/supervisor-user-dto.model';
import { ChangeEvaluatorResult } from 'src/app/model/observation/common/change-evaluator-result.model';
import { CustomValidators } from 'src/app/validators/custom-validators';

/**
 * Picks a new evaluator for an observation and lets the user decide whether the affected
 * evaluators are emailed about it. Emailing is on by default because the point of the feature
 * is that inheriting evaluators find out without watching the roster.
 */
@Component({
    selector: 'paetep-change-evaluator-modal',
    templateUrl: './paetep-change-evaluator-modal.component.html',
    styleUrls: ['./paetep-change-evaluator-modal.component.scss']
})
export class PaetepChangeEvaluatorModalComponent implements OnInit {
    @Input() evaluators: SupervisorUserDTO[] = [];
    @Input() currentEvaluatorId?: string;

    public form!: FormGroup;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder
    ) { }

    /**
     * Builds the form with the current evaluator pre-selected and email notifications switched on. The
     * dialog exists to change the evaluator, so it cannot be submitted until a different one is chosen.
     */
    ngOnInit(): void {
        this.form = this.formBuilder.group({
            evaluatorId: [this.currentEvaluatorId ?? null, [Validators.required, CustomValidators.mustDifferFrom(this.currentEvaluatorId)]],
            sendEmailNotification: [true]
        });
    }

    /**
     * Closes the modal with the user's choices when an evaluator has been selected; does nothing otherwise
     * so the required-field message stays visible.
     *
     * @param form The submitted form's value and validity.
     */
    onSubmit({ value, valid }: { value: ChangeEvaluatorResult, valid: boolean }): void {
        if (valid) {
            this.activeModal.close(value);
        }
    }

    /**
     * Dismisses the modal without changing anything.
     */
    cancel(): void {
        this.activeModal.dismiss('cancel');
    }
}
